import { render } from "./List.vue?vue&type=template&id=2f979c45&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=2f979c45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f979c45"],['__file',"src/vue/components/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f979c45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f979c45', __exports__)) {
    api.reload('2f979c45', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=2f979c45&scoped=true", () => {
    api.rerender('2f979c45', render)
  })

}


export default __exports__